import { useTranslation } from 'react-i18next';

const processes = [
  {
    number: '01',
    icon: 'ri-search-line',
    titleKey: 'process.step1.title',
    descKey: 'process.step1.desc'
  },
  {
    number: '02',
    icon: 'ri-pencil-ruler-2-line',
    titleKey: 'process.step2.title',
    descKey: 'process.step2.desc'
  },
  {
    number: '03',
    icon: 'ri-code-s-slash-line',
    titleKey: 'process.step3.title',
    descKey: 'process.step3.desc'
  },
  {
    number: '04',
    icon: 'ri-bug-line',
    titleKey: 'process.step4.title',
    descKey: 'process.step4.desc'
  }
];

export default function Process() {
  const { t } = useTranslation();

  return (
    <section id="process" className="py-24 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-[5%]">
        <h2 className="text-5xl font-bold text-gray-900 text-center mb-16">
          {t('process.title')}
        </h2>

        <div className="grid grid-cols-4 gap-10 relative">
          {processes.map((process, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-2xl p-8 h-[400px] flex flex-col relative overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
                <div className="absolute top-4 left-4 text-[120px] font-extralight text-gray-200 leading-none select-none">
                  {process.number}
                </div>
                
                <div className="relative z-10 flex flex-col items-center text-center mt-8">
                  <div className="w-16 h-16 flex items-center justify-center mb-6">
                    <i className={`${process.icon} text-6xl text-[#14B8A6]`}></i>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {t(process.titleKey)}
                  </h3>
                  
                  <div className="w-10 h-0.5 bg-gray-300 mb-6"></div>
                  
                  <p className="text-base text-gray-600 leading-relaxed">
                    {t(process.descKey)}
                  </p>
                </div>
              </div>
              
              {index < processes.length - 1 && (
                <div className="absolute top-1/2 -right-5 transform -translate-y-1/2 z-20">
                  <div className="w-10 h-0.5 border-t-2 border-dashed border-gray-400"></div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            {t('process.subtitle')}
          </p>
        </div>
      </div>
    </section>
  );
}
